// extracted by mini-css-extract-plugin
module.exports = {"helpful":"_3W2vAi","helpfulText":"_1llRSh","shine-lines":"O_9jA-"};